const Swal = require('sweetalert2')
window.Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
})

window.swal = (...args) => {
  if(args.length === 1){
    args = args[0]
    if(args.type != null && args.icon == null){
      args.icon = args.type
      delete args.type
    }
    args.showCancelButton = true
    args.confirmButtonText = 'Aceptar'
    args.cancelButtonText = 'Cancelar'
  }
  else{
    args = {
      title: args[0],
      text: args[1],
      icon: args[2],
      confirmButtonText: "Aceptar"
    }
  }
  if(args.icon === "success"){
    if(args[3] != null){
      return Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: args[3],
        timerProgressBar: true,
      }).fire(args)
    }
    return Toast.fire(args)
  }
  return new Promise((resolve, reject, ) =>{
    Swal.fire(args).then((result) => {
      if (result.isConfirmed) {
        resolve(true)
      }
      else{
        reject()
      }
    })
  })
}

window.swalQ = (...args) => {
  return swal({
    title: args[0],
    text: args[1],
    icon: args[2],
  })
}
